import api from "services/api";
import {toQueryFilters} from "utils";
import { API_URL_VERSION } from "constants/environment";

export const ENDPOINT_BOATS_LIST = API_URL_VERSION + 'boats'
export const ENDPOINT_GET_VEHICLE = API_URL_VERSION + 'consulta-veiculos/placa'
export const ENDPOINT_GET_AGENTS = API_URL_VERSION + 'agentes'
export const ENDPOINT_UPLOAD_ASSET = API_URL_VERSION + 'assets/upload'

export const boatService = {
    list: async (params = {}) => {
        try {
            const response = await api.get(`${ENDPOINT_BOATS_LIST}?${toQueryFilters(params)}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "boat.messages.errors.list";
        }
    },

    create: async (data) => {
        try {
            const response = await api.post(ENDPOINT_BOATS_LIST, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "boat.messages.errors.create";
        }
    },

    find: async (id) => {
        try {
            const response = await api.get(`${ENDPOINT_BOATS_LIST}/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "boat.messages.errors.find";
        }
    },

    downloadPdf: async (id, logoUrl) => {
        try {
            const response = await api.get(`${ENDPOINT_BOATS_LIST}/${id}/pdf`, {
                params: {logoUrl},
                responseType: "blob",
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "boat.messages.errors.export-pdf";
        }
    },

    update: async (id, data) => {
        try {
            const response = await api.patch(`${ENDPOINT_BOATS_LIST}/${id}`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "boat.messages.errors.update";
        }
    },

    findVehicle: async (vehiclePlate) => {
        try {
            const response = await api.get(`${ENDPOINT_GET_VEHICLE}/${vehiclePlate}`);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "boat.messages.errors.find-vehicle";
        }
    },

    getAgents: async () => {
        try {
            const response = await api.get(`${ENDPOINT_GET_AGENTS}`);
            return response.data?._embedded?.agent_list || [];
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "boat.messages.errors.list-agents";
        }
    },

    uploadAsset: async (formData) => {
        try {
            const response = await api.post(`${ENDPOINT_UPLOAD_ASSET}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || error.response?.data?.erros_validacao || "boat.messages.errors.upload-asset";
        }
    }
};